import { useQuery } from '@tanstack/react-query'
import { fetchCustomViewNoteHistory } from '@/api/customViewsApi'
import type { ContentType } from '@/types/api'

/**
 * Prior revisions of one shared note. Only fetched while the history dialog is open — the history
 * table grows with every edit and nobody needs it until they are looking for something lost.
 */
export function useCustomViewNoteHistory(
  viewId: number | null,
  contentType: ContentType,
  entityId: number,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['custom-view-note-history', viewId, contentType, entityId] as const,
    queryFn: () => fetchCustomViewNoteHistory(viewId!, contentType, entityId),
    enabled: enabled && viewId !== null,
    staleTime: 0,
  })
}
